export const filterTeethByRange = (from: number, to: number, jawTeeth: string[]) => {
    const fromIndex = jawTeeth.findIndex((t) => parseInt(t) === from);
    const toIndex = jawTeeth.findIndex((t) => parseInt(t) === to);
    if (fromIndex !== -1 && toIndex !== -1) {
        return jawTeeth.slice(Math.min(fromIndex, toIndex), Math.max(fromIndex, toIndex) + 1);
    }
    return [];
};
